import { UserRole } from '@/lib/types';
import { useAuthContext } from '@/contexts/AuthContext';

const useHasUserRole = (roles: UserRole[]) => {
  const { user } = useAuthContext();

  return user?.roles.some((r) => roles.includes(r.name)) || false;
};

export default useHasUserRole;
